// Русский
export default {
    // Research papers page (/research)
    "nav.globe": "Глобус",
    "nav.research": "Исследования",
    "rs.title": "Научные исследования",
    "rs.sub": "Новые исследования по количественным финансам и центральным банкам от arXiv, ФРС, ЕЦБ, БМР и NBER. Бесплатно на сайте источника; обновляется каждые 6 часов.",
    "rs.search": "Поиск по названиям, авторам, аннотациям…",
    "rs.allTopics": "Все темы",
    "rs.allSources": "Все источники",
    "rs.allCountries": "Все страны",
    "rs.count": "Исследований: {n}",
    "rs.none": "Нет исследований по этим фильтрам.",
    "rs.clear": "Сбросить фильтры",
    "rs.download": "Скачать PDF с {source}",
    "rs.read": "Читать на {source}",
    "rs.onGlobe": "Открыть {country} на глобусе",
    "rs.note": "Названия, авторы и аннотации ведут к первоисточникам; PDF открываются на их сайтах. Исследования, а не финансовый совет.",
    "rs.global": "Весь мир",
    "rs.loadMore": "Показать ещё",
    "rs.details": "Подробнее",
    "rs.copy": "Копировать ссылку",
    "rs.copied": "Ссылка скопирована",
    "rs.published": "Опубликовано",
    "panel.research": "Исследования о стране: {country}",
    "panel.researchAll": "Все исследования →",
    "rt.trading": "Торговля и структура рынка",
    "rt.portfolio": "Портфели и инвестиции",
    "rt.risk": "Риск",
    "rt.pricing": "Деривативы и модели оценки",
    "rt.forecasting": "ИИ и прогнозы",
    "rt.crypto": "Криптовалюты и цифровые активы",
    "rt.macro": "Экономика и центробанки",
    "topic.r-trading": "Исследования торговли изучают, как формируются цены и исполняются заявки: стратегии, биржевые стаканы, ликвидность и издержки.",
    "topic.r-portfolio": "Исследования портфелей отвечают на вопрос, как сочетать вложения: какие факторы объясняют доходность, как балансировать риск и доходность и как инвестировать на пенсию.",
    "topic.r-risk": "Исследования риска оценивают, что может пойти не так: крупные убытки, обвалы рынка, банкротства банков и способы защиты.",
    "topic.r-pricing": "Исследования оценки создают математику для расчёта стоимости опционов и других контрактов, а также модели волатильности.",
    "topic.r-forecasting": "Исследования ИИ и прогнозов проверяют, могут ли машинное обучение, языковые модели и статистика предсказывать цены или экономику и насколько надёжно.",
    "topic.r-crypto": "Криптоисследования изучают криптовалюты, стейблкоины, блокчейны и токенизированные активы: как они торгуются и какие несут риски.",
    "topic.r-macro": "Экономические исследования рассматривают рост, инфляцию, процентные ставки и политику центробанков, которые двигают рынки месяцами и годами.",
    'lang.label': 'Язык',
    'nav.reports': 'Отчёты',
    'nav.stocks': 'Наблюдение за акциями',
    loading: 'Загружаем мировые новости…',
    'err.title': 'Не удалось загрузить',
    'err.msg': 'При загрузке приложения произошла ошибка.',
    'err.retry': 'Повторить',
    atlas: 'Атлас',
    'search.label': 'Поиск стран',
    'search.ph': 'Поиск стран или кодов…',
    'filter.region': 'Регион',
    'filter.allRegions': 'Все регионы',
    'filter.window': 'Период',
    'filter.topic': 'Тема',
    'filter.all': 'Все',
    'stage.title': 'Рынки прямо сейчас',
    legend: 'Легенда',
    lastUpdate: 'Обновлено',
    pauseRotation: 'Остановить вращение',
    resumeRotation: 'Возобновить вращение',
    hint: 'Тяните, чтобы вращать · нажмите на точку, чтобы открыть страну',
    'panel.latest': 'Последние',
    'quiet.none': 'За этот период новостей нет.',
    'quiet.sub': 'Выберите более длинный период (7Д или 30Д) или подпишитесь на эту страну, чтобы она оставалась в вашем списке.',
    'footer.about': 'О проекте',
    'footer.privacy': 'Конфиденциальность',
    'footer.terms': 'Условия',
    follow: '☆ Следить',
    following: '★ Вы следите',
    followingGroup: 'Отслеживаемые',
    explain: 'Объяснить',
    hideExplain: 'Скрыть объяснение',
    share: 'Поделиться',
    whyMatter: 'Почему это может быть важно',
    disclaimer: 'Образовательный контекст, а не финансовая рекомендация.',
    readAt: 'Читать полностью: {source}',
    translate: 'Перевести',
    showing: 'Показано {n} из {total}',
    loadMore: 'Загрузить ещё {n}',
    loadingShort: 'Загрузка…',
    'story.one': '{n} новость',
    'story.few': '{n} новости',
    'story.many': '{n} новостей',
    'story.other': '{n} новости',
    noStories: 'нет новостей',
    justNow: 'Только что',
    minAgo: '{n} мин назад',
    hAgo: '{n} ч назад',
    dAgo: '{n} д назад',
    'range.24h': 'последние 24 часа',
    'range.7d': 'последние 7 дней',
    'range.30d': 'последние 30 дней',
    'range.all': 'всё время',
    'cont.Africa': 'Африка',
    'cont.Asia': 'Азия',
    'cont.Europe': 'Европа',
    'cont.North America': 'Северная Америка',
    'cont.Oceania': 'Океания',
    'cont.South America': 'Южная Америка',
    'cat.markets': 'Рынки',
    'cat.economy': 'Экономика',
    'cat.central-banks': 'Центробанки',
    'cat.policy': 'Политика и геополитика',
    'cat.companies': 'Компании',
    today: 'Сегодня',
    'today.top': 'Мир за 60 секунд',
    'today.banks': 'Решения центробанков',
    'today.mine': 'Ваши страны',
    'today.emptyTop': 'Сегодня пока нет важных новостей. Загляните позже.',
    'today.emptyMine': 'Нажмите ☆ Следить у любой страны, чтобы закрепить её здесь.',
    'today.note': 'Заголовки ведут на сайты первоисточников. Только образовательный контекст, не финансовая рекомендация.',
    'today.open': 'Открыть: {country}',
    close: 'Закрыть',
    'cal.timeVaries': 'время меняется',
    'cal.yourTime': '{time} по вашему времени',
    'cal.in': 'через {t}',
    'cal.today': 'Решение объявляется сегодня',
    'bank.fed': 'ФРС США',
    'bank.ecb': 'Европейский центральный банк',
    'bank.boe': 'Банк Англии',
    'bank.boj': 'Банк Японии',
    'auth.signIn': 'Войти',
    'auth.account': 'Аккаунт',
    'auth.btnTitle': 'Бесплатный аккаунт: ваши страны на всех устройствах',
    'auth.freeTitle': 'Бесплатный аккаунт',
    'auth.freeSub': "Сохраняйте выбранные страны на всех устройствах. Без пароля: мы отправим вам одноразовый код по email.",
    'auth.emailBtn': "Отправить код для входа",
    'auth.sending': 'Отправляем…',
    'auth.check': 'Проверьте почту: ссылка действует 20 минут.',
    "auth.codeTitle": "Проверьте почту",
    "auth.codeSent": "Мы отправили 6-значный код на {email}. Введите его здесь:",
    "auth.codeLabel": "Код для входа",
    "auth.codeBtn": "Войти",
    "auth.junk": "Не видите письма? Оно может прийти через минуту. Проверьте также папку «Спам» и отметьте письмо как «Не спам», чтобы следующие приходили во «Входящие».",
    "auth.otherEmail": "Другой email",
    'auth.dev': 'Режим разработки (почтовый сервер не настроен):',
    'auth.devLink': 'нажмите здесь, чтобы войти',
    'auth.fine': 'Мы используем ваш email только для входа. См. {link}.',
    'auth.privacy': 'уведомление о конфиденциальности',
    'auth.yourAccount': 'Ваш аккаунт',
    'auth.signedInAs': 'Вы вошли как {email}',
    'auth.followCount': 'Отслеживаемых стран: {n}. Синхронизировано на всех устройствах.',
    'auth.signOut': 'Выйти',
    'auth.delete': 'Удалить аккаунт',
    "auth.confirmDelete": "Удалить аккаунт? Ваш email и сохранённые страны будут удалены, и вы перестанете получать письма NewsNetWide. Это нельзя отменить.",
    'auth.deletedTitle': 'Аккаунт удалён',
    "auth.deletedSub": "Ваш email, сохранённые страны и подписка на письма удалены.",
    'auth.inTitle': 'Вы вошли',
    'auth.inSub': 'Добро пожаловать, {email}. Отслеживаемые страны теперь сохранены в вашем аккаунте.',
    'auth.expired': 'Срок действия ссылки истёк. Запросите новую ниже.',
    'auth.used': 'Эта ссылка уже использована или недействительна. Запросите новую ниже.',
    'share.source': 'Источник',
    'share.tagline': 'Все новости, движущие рынки, на одном глобусе',
    'share.notAdvice': 'Новости, а не финансовая рекомендация',
    'mc.open': 'Открыта',
    'mc.pre': 'Премаркет',
    'mc.post': 'Постмаркет',
    'mc.night': 'Ночная сессия',
    'mc.break': 'Обеденный перерыв',
    'mc.closed': 'Закрыта',
    'mc.holiday': 'Выходной',
    'mc.closesIn': 'Закроется через {t}',
    'mc.opensIn': 'Откроется через {t}',
    'mc.endsIn': 'Завершится через {t}',
    'mc.reopensIn': 'Откроется снова через {t}',
    'mc.preIn': 'Премаркет через {t}',
    'mc.afterIn': 'Постмаркет через {t}',
    'mc.nightIn': 'Ночная сессия через {t}',
    'mc.openCount': 'Открыто: {n}',
    'mc.all': 'Все рынки',
    "mc.title": "Часы торгов",
    "side.countries": "Страны",
    "side.menu": "Меню",
    "tools.pricingSub": "Тарифы и что входит в каждый",
    'mc.noHolidays': 'праздники не учтены',
    'mc.local': 'местное время',
    'mc.note': 'Основные часы торгов по местному времени каждой биржи. Праздники учтены для рынков США, Великобритании, Германии и Euronext Paris (2026–27); другие биржи могут закрываться в местные праздники. Ночные сессии — это торги фьючерсами на индексы (Токио OSE, Гонконг HKFE).',
    'topic.markets': 'Рыночные новости — о ценах акций, облигаций, валют и сырья: что покупают и продают инвесторы и почему.',
    'topic.economy': 'Экономические новости (рост, занятость, инфляция, торговля) влияют на прибыль компаний и решения центробанков в ближайшие месяцы.',
    'topic.central-banks': 'Центробанки устанавливают процентные ставки — цену денег, от которой зависят кредиты, сбережения, валюты и цены активов.',
    'topic.policy': 'Решения правительств (налоги, бюджеты, торговые правила, санкции, выборы, конфликты) могут менять издержки и риски целых отраслей.',
    'topic.companies': 'Новости компаний (результаты, сделки, сокращения) могут двигать их акции, а иногда и весь сектор.',
    "snap.title": "Обзор для инвестора",
    "snap.source": "Последние официальные годовые данные · World Bank Open Data. Контекст, а не прогноз или рекомендация.",
    "snap.gdp_growth": "Рост ВВП",
    "snap.inflation": "Инфляция",
    "snap.unemployment": "Безработица",
    "snap.gdp_per_capita": "ВВП на человека",
    "snap.current_account": "Текущий счёт",
    "snap.exports": "Экспорт",
    "snap.ofGdp": "ВВП",
    "snap.gdp.shrink": "Экономика сокращается.",
    "snap.gdp.slow": "Медленный рост.",
    "snap.gdp.moderate": "Умеренный рост.",
    "snap.gdp.fast": "Быстрый рост.",
    "snap.inf.deflation": "Цены снижаются (дефляция).",
    "snap.inf.target": "Близко к цели ~2 %, к которой стремятся большинство центробанков.",
    "snap.inf.above": "Выше обычных целей центробанков.",
    "snap.inf.high": "Высокая инфляция: деньги быстро обесцениваются.",
    "snap.unemp.low": "Низкая: рынок труда напряжён.",
    "snap.unemp.moderate": "Умеренная.",
    "snap.unemp.high": "Высокая: многие не могут найти работу.",
    "snap.gdppc.note": "Средний объём производства на человека: приблизительная мера благосостояния страны.",
    "snap.ca.surplus": "Профицит: получает из-за рубежа больше, чем тратит.",
    "snap.ca.deficit": "Дефицит: тратит за рубежом больше, чем получает, и зависит от иностранных денег.",
    "snap.exp.very": "Сильно зависит от торговли: чувствительна к пошлинам и мировому спросу.",
    "snap.exp.open": "Открытая торговая экономика.",
    "snap.exp.domestic": "Держится в основном на внутреннем рынке.",
    "auth.since": "С нами с {date}",
    "auth.followed": "Страны, за которыми вы следите",
    "auth.noneFollowed": "Пока нет. Нажмите ☆ Следить у любой страны, чтобы добавить её сюда.",
    "auth.unfollow": "Перестать следить за {country}",
    "auth.email": "Почта",
    "auth.prefUpdates": "Новости NewsNetWide",
    "auth.prefUpdatesSub": "Новые функции и новости сайта",
    "auth.prefNews": "Рассылка",
    "auth.prefNewsSub": "Главные новости рынков",
    "auth.saved": "Сохранено.",
    "auth.prefsError": "Настройки почты сейчас недоступны.",
    "auth.plan": "Тариф",
    "auth.seePlans": "Тарифы",
    "auth.manage": "Управление подпиской",
    "auth.trialUntil": "пробный период до {date}",
    "auth.renews": "продлится {date}",
    "auth.endsOn": "закончится {date}",
    "auth.briefing": "Утренний обзор",
    "auth.briefingOn": "Присылать мне утренний обзор",
    "auth.briefingSub": "Главные новости стран, на которые вы подписаны, и ближайшие важные даты. Отписаться можно в любой момент.",
    "auth.briefingNone": "Вы пока не подписаны ни на одну страну, поэтому обзор начнётся с главных мировых новостей.",
    "auth.briefingCount": "Стран в вашем обзоре: {n}",
    "auth.briefingAt": "Присылать в",
    "auth.briefingTz": "ваше время ({tz})",
    "auth.briefingPreview": "Пример на сегодня ↗",
    "panel.page": "Страница страны ↗",
    "footer.countries": "Страны",
    glossary: {
        'central-bank': ['Центральный банк', 'Учреждение, которое устанавливает процентные ставки в стране и управляет денежной массой.', 'Его решения меняют стоимость кредита для всех и двигают облигации, акции и валюту.'],
        fed: ['ФРС (Федеральная резервная система)', 'Центральный банк США; его комитет (FOMC) устанавливает ставки в США.', 'Ставки в США влияют на стоимость кредита и потоки инвестиций по всему миру.'],
        ecb: ['Европейский центральный банк (ЕЦБ)', 'Центральный банк 20 стран, использующих евро.', 'Его решения влияют на ипотеку, кредиты бизнесу и курс евро.'],
        boe: ['Банк Англии', 'Центральный банк Великобритании; его Комитет по денежно-кредитной политике устанавливает ставки.', 'Его решения двигают фунт, британские гособлигации и стоимость кредита.'],
        boj: ['Банк Японии', 'Центральный банк Японии.', 'Изменение очень низких японских ставок может двигать иену и мировые потоки капитала.'],
        'interest-rate': ['Процентная ставка', 'Цена заёмных денег, обычно в процентах годовых.', 'Высокие ставки удорожают кредиты и сдерживают расходы; низкие действуют наоборот.'],
        'rate-cut': ['Снижение ставки', 'Центробанк снижает процентную ставку.', 'Дешёвый кредит может поддержать расходы и прибыль, но иногда говорит о тревоге за экономику.'],
        'rate-hike': ['Повышение ставки', 'Центробанк повышает процентную ставку.', 'Обычно цель — замедлить инфляцию; кредиты для семей и компаний дорожают.'],
        'basis-points': ['Базисные пункты', 'Один базисный пункт — 0,01 %; 25 базисных пунктов — четверть процентного пункта.', 'Изменения ставок указывают в базисных пунктах — так видно масштаб движения.'],
        qe: ['Количественное смягчение (QE)', 'Центробанк покупает (QE) или сокращает (QT) большие объёмы облигаций, чтобы влиять на долгосрочные ставки.', 'Это меняет объём денег, проходящих через финансовые рынки.'],
        inflation: ['Инфляция', 'Темп роста цен; обычно измеряется индексом потребительских цен (ИПЦ).', 'Высокая инфляция может удерживать ставки высокими и снижает покупательную способность.'],
        gdp: ['ВВП', 'Валовой внутренний продукт: общая стоимость товаров и услуг, произведённых экономикой.', 'Это самый широкий показатель того, растёт экономика или сокращается.'],
        recession: ['Рецессия', 'Значительный и широкий спад экономической активности, часто два квартала падения ВВП.', 'Рецессии обычно означают меньшую прибыль компаний и рост безработицы.'],
        unemployment: ['Безработица', 'Доля людей, которые хотят работать, но не имеют работы; данные по занятости показывают новые рабочие места.', 'Данные о рынке труда показывают силу экономики и влияют на центробанки.'],
        pmi: ['Индекс PMI', 'Индекс деловой активности: ежемесячный опрос компаний. Выше 50 — рост.', 'Это один из самых ранних сигналов о направлении экономики.'],
        'trade-deficit': ['Торговый баланс', 'Разница между экспортом и импортом страны.', 'Большие дисбалансы могут влиять на валюту и вести к торговым спорам.'],
        tariff: ['Пошлина', 'Налог на импортные товары.', 'Пошлины удорожают импорт и могут снижать продажи и прибыль экспортёров.'],
        sanctions: ['Санкции', 'Ограничения, которые одна страна вводит на торговлю или финансы с другой.', 'Они могут закрывать рынки, нарушать цепочки поставок и двигать цены на сырьё.'],
        budget: ['Бюджет и фискальная политика', 'Как государство собирает налоги, тратит и занимает.', 'Крупные дефициты или стимулы могут влиять на рост, доходность облигаций и валюту.'],
        'bond-yield': ['Доходность облигаций', 'Доход инвестора по облигации; когда цена облигации падает, доходность растёт.', 'Доходность госдолга задаёт базовую стоимость кредита во всей экономике.'],
        index: ['Фондовый индекс', 'Корзина акций, отражающая рынок, например S&P 500 (500 крупных компаний США).', 'Индексы сводят состояние целого рынка к одному числу.'],
        'sell-off': ['Распродажа', 'Период, когда многие инвесторы продают одновременно и цены быстро падают.', 'Часто отражает страх или плохие новости; ничего не говорит наверняка о будущем.'],
        volatility: ['Волатильность', 'Насколько сильно и быстро меняются цены.', 'Высокая волатильность — больше неопределённости и сильнее колебания в обе стороны.'],
        currency: ['Валютный курс', 'Цена одной валюты, выраженная в другой.', 'Колебания курсов меняют стоимость импорта, поездок и иностранных инвестиций.'],
        oil: ['Цены на нефть', 'Рыночная цена сырой нефти; эталоны — Brent и WTI. ОПЕК объединяет страны-производители.', 'Нефть влияет на стоимость топлива, перевозок и производства, а значит, на инфляцию.'],
        gold: ['Золото', 'Золото как биржевой товар.', 'Многие инвесторы покупают его во времена неопределённости, поэтому цена отражает тревогу рынка.'],
        crypto: ['Криптовалюта', 'Цифровые активы вроде биткоина, торгующиеся круглосуточно без центробанка.', 'Цены очень волатильны и реагируют на регулирование и аппетит к риску.'],
        etf: ['ETF', 'Биржевой фонд, который торгуется как акция и обычно следует за индексом.', 'ETF — распространённый и недорогой способ вложиться в целый рынок.'],
        earnings: ['Прибыль', 'Прибыль компании за период, часто в расчёте на акцию (EPS).', 'Результаты выше или ниже ожиданий аналитиков часто двигают курс акций.'],
        revenue: ['Выручка', 'Все деньги, полученные компанией от продаж до вычета расходов.', 'Рост выручки показывает, растёт ли спрос на продукцию компании.'],
        guidance: ['Прогноз компании', 'Собственный прогноз компании по будущим результатам.', 'Изменения прогноза часто важны для инвесторов не меньше прошлых результатов.'],
        ipo: ['IPO', 'Первичное размещение: компания впервые продаёт акции на бирже.', 'Это даёт публике возможность инвестировать и показывает спрос на новые размещения.'],
        merger: ['Слияния и поглощения', 'Одна компания объединяется с другой или покупает её.', 'Сделки могут менять конкуренцию и часто двигают акции обеих компаний.'],
        buyback: ['Обратный выкуп акций', 'Компания выкупает собственные акции с рынка.', 'Это возвращает деньги акционерам и сокращает число акций; гарантией стоимости не является.'],
        dividend: ['Дивиденд', 'Часть прибыли, выплачиваемая акционерам.', 'Изменение дивидендов показывает уверенность компании в своих денежных потоках.'],
        layoffs: ['Сокращения', 'Компания уменьшает число сотрудников.', 'Это может говорить о давлении издержек или реструктуризации и влияет на рынок труда.'],
        bankruptcy: ['Банкротство', 'Юридическая процедура, когда компания не может платить по долгам.', 'Акционеры обычно теряют почти всё; кредиторы могут вернуть часть средств.'],
    },
    // Calendar (/calendar)
    "nav.calendar": "Календарь",
    "nav.tools": "Инструменты",
    "nav.pricing": "Цены",
    "tools.soon": "СКОРО",
    "tools.briefing": "Утренний обзор",
    "tools.briefingSub": "Новости ваших стран по email каждое утро",
    "tools.calculators": "Финансовые калькуляторы",
    "tools.calculatorsSub": "Сложный процент, цели накоплений, комиссии",
    "tools.holdings": "Мониторинг активов",
    "tools.holdingsSub": "Новости о компаниях, которыми вы владеете",
    "tools.papers": "Анализ статей",
    "tools.papersSub": "Любая научная статья простым языком",
    "tools.montecarlo": "Симулятор Монте-Карло",
    "tools.montecarloSub": "Накопления, трейдинг и опционные стратегии, с PDF",
    "cal.title": "Экономический календарь",
    "cal.sub": "Решения центробанков, ключевые экономические данные, выходные на биржах и праздники — из официальных источников, в вашем часовом поясе.",
    "cal.todayLabel": "Сегодня",
    "cal.tomorrow": "Завтра",
    "cal.yesterday": "Вчера",
    "cal.allDay": "Весь день",
    "cal.now": "сейчас",
    "cal.inDH": "через {d} дн. {h} ч",
    "cal.inHM": "через {h} ч {m} мин",
    "cal.inM": "через {m} мин",
    "cal.decision": "{bank}: решение по ставке",
    "cal.closed": "{exchange} закрыта",
    "cal.early": "{exchange} закрывается раньше",
    "cal.estimated": "ориентировочная дата",
    "cal.yourTz": "Время в вашем часовом поясе ({tz})",
    "cal.type.public_holiday": "Праздники",
    "cal.allCountries": "Все страны",
    "cal.yourCountries": "Ваши страны",
    "cal.noFollows": "Отслеживайте страны на глобусе, чтобы фильтровать по ним здесь.",
    "cal.addToCal": "Добавить в календарь",
    "cal.subscribe": "Подписаться",
    "cal.subscribeHint": "Скопируйте ссылку в Google Календарь, Календарь Apple или Outlook («добавить по URL»). Он обновляется сам.",
    "cal.copied": "Ссылка скопирована",
    "cal.source": "Официальный источник",
    "cal.relatedNews": "Новости: {country}",
    "cal.period": "Период: {period}",
    "cal.none": "По этим фильтрам ничего не запланировано.",
    "cal.error": "Календарь сейчас недоступен. Попробуйте чуть позже.",
    "cal.comingUp": "Скоро",
    "cal.fullCalendar": "Весь календарь",
    "cal.euroArea": "Еврозона",
    "cal.note": "Даты и время — от центробанков, бирж и статистических ведомств (ссылка у каждого события). Праздники: открытая библиотека «holidays» (MIT). Мы никогда не показываем прогнозы. Новости и контекст, а не финансовая консультация.",
    "cal.series.us_cpi": "Потребительские цены США (CPI)",
    "cal.series.us_jobs": "Отчёт о занятости США",
    "cal.series.us_ppi": "Цены производителей США (PPI)",
    "cal.series.us_jolts": "Вакансии в США (JOLTS)",
    "cal.series.us_eci": "Индекс стоимости рабочей силы США",
    "cal.series.us_gdp": "ВВП США",
    "cal.series.us_pce": "Доходы и расходы населения США (PCE)",
    "cal.series.us_trade": "Торговый баланс США",
    "cal.series.ea_hicp_flash": "Инфляция в еврозоне (предварительная)",
    "cal.series.ea_hicp": "Инфляция в еврозоне (окончательная)",
    "cal.series.ea_gdp_flash": "ВВП еврозоны (первая оценка)",
    "cal.series.ea_gdp": "ВВП и занятость в еврозоне",
    "cal.series.ea_unemployment": "Безработица в еврозоне",
    "cal.series.ea_retail": "Розничные продажи в еврозоне",
    "cal.series.uk_cpi": "Потребительские цены Великобритании (CPI)",
    "cal.series.uk_gdp_q": "ВВП Великобритании (квартал)",
    "cal.series.uk_gdp_m": "ВВП Великобритании (месяц)",
    "cal.series.uk_jobs": "Рынок труда Великобритании",
    "cal.series.uk_retail": "Розничные продажи Великобритании",
    "cal.series.au_cpi": "Потребительские цены Австралии (CPI)",
    "cal.series.au_jobs": "Рынок труда Австралии",
    "cal.series.au_gdp": "ВВП Австралии",
    "bank.snb": "Швейцарский национальный банк",
    "bank.boc": "Банк Канады",
    "bank.rba": "Резервный банк Австралии",
    "bank.rbnz": "Резервный банк Новой Зеландии",
    "bank.riksbank": "Риксбанк (Швеция)",
    "bank.norges": "Банк Норвегии",
    "bank.rbi": "Резервный банк Индии",
    "cal.promise1": "Только официальные источники",
    "cal.promise2": "Без прогнозов — только даты и результаты",
    "cal.promise3": "Бесплатная подписка на календарь",
    "cal.yourTimeShort": "ваше время",
    "cal.unitD": "дн.",
    "cal.unitH": "ч",
    "cal.unitM": "мин",
    "cal.approxNote": "Время примерное: банк не фиксирует его заранее",
    "cal.then": "Далее:",
    "cal.nextDecisions": "Ближайшие решения по ставкам",
    "cal.bankCalendars": "Официальные календари банков · отсчёт до объявления",
    "cal.marketsWeek": "Биржи на этой неделе",
    "cal.mktAside": "Закрытий на неделе: {n} · время в {tz}",
    "cal.mktNote": "Только основная торговая сессия. Закрытия — по официальному календарю каждой биржи.",
    "cal.exchange": "Биржа",
    "cal.rightNow": "Сейчас",
    "cal.mkt.open": "Открыта",
    "cal.mkt.pre": "Ещё не открыта",
    "cal.mkt.break": "Обеденный перерыв",
    "cal.mkt.closedToday": "Сегодня закрыта",
    "cal.mkt.closed": "Закрыта",
    "cal.mkt.closesAt": "закроется в {time} (ваше время)",
    "cal.mkt.opensAt": "откроется в {time} (ваше время)",
    "cal.mkt.earlyAt": "Закроется раньше, в {time}",
    "cal.local": "местное время",
    "cal.country": "Страна",
    "cal.types": "Типы событий",
    "cal.group.central_bank": "Центробанки",
    "cal.group.data_release": "Экономические данные",
    "cal.group.markets": "Закрытия бирж",
    "cal.group.public_holiday": "Праздники",
    "cal.badge.central_bank": "Решение по ставке",
    "cal.badge.data_release": "Публикация данных",
    "cal.badge.market_closed": "Биржа закрыта",
    "cal.badge.early_close": "Ранее закрытие",
    "cal.badge.public_holiday": "Праздник",
    "cal.closesEarly": "ранее закрытие",
    "cal.noTrading": "торгов нет весь день",
    "cal.released": "Опубликовано",
    "cal.seeFigure": "Смотреть официальную цифру",
    "cal.sourceShort": "Источник",
    "cal.news": "Новости",
    "cal.openNote": "{exchange} открыта",
    "cal.plusMore": "ещё: {n}",
    "cal.oneEvent": "1 событие",
    "cal.nEvents": "Событий: {n}",
    "cal.oneHoliday": "1 праздник",
    "cal.nHolidays": "Праздников: {n}",
    "cal.nowLine": "Сейчас · {time}",
    "cal.weekendClosed": "Выходные: биржи закрыты.",
    "cal.nothingDay": "Ничего не запланировано.",
    "cal.thisWeek": "Эта неделя",
    "cal.nextWeekLabel": "Следующая неделя",
    "cal.earlier": "Ранее на этой неделе",
    "cal.show": "Показать",
    "cal.tryAll": "Выберите все типы событий или отключите «Ваши страны».",
    "cal.reset": "Сбросить фильтры",
    "cal.prevWeek": "Предыдущая неделя",
    "cal.nextWeek": "Следующая неделя",
    "cal.moreWeek": "Показать следующую неделю",
    "cal.subscribeTitle": "Подписаться на этот календарь",
    "cal.feedAddress": "Адрес календаря",
    "cal.copyLink": "Скопировать ссылку",
    "cal.subFine": "Бесплатно, без аккаунта. Учитывает выбранные фильтры. Новости и контекст, а не финансовая консультация.",
    "cal.impact": "Влияние",
    "cal.imp.high": "Высокое",
    "cal.imp.medium": "Среднее",
    "cal.imp.low": "Низкое",
    "cal.impTip.high": "обычно двигает ставки, валюты и акции",
    "cal.impTip.medium": "рынки следят, но реагируют реже",
    "cal.impTip.low": "фон: праздники, второстепенные данные",
    "cal.impNote": "По типу события, а не прогноз.",
    "cal.impAll": "Все",
    "cal.impMediumUp": "Среднее +",
    "cal.impHighOnly": "Только высокое",
    "cal.nHigh": "Высокое влияние: {n}",
    "cal.addShort": "Добавить",
};
